const creditsHR = {
    "view": {
        "form": {
            "title": "Naruči Kredite",
            "label": {
                "quantity": "Količina"
            },
            "placeholder": {
                "quantity": "Odaberi Količinu"
            },
            "help_text": {
                "quantity": "Količina kredita koju želite naručiti."
            },
            "button": {
                "placeOrder": "Naruči"
            },
            "options": {
                "quantity": {
                    "selectQuantity": "Odaberi Količinu",
                    "1Credit": "1 Kredit",
                    "2Credits": "2 Kredita",
                    "3Credits": "3 Kredita",
                    "4Credits": "4 Kredita",
                    "5Credits": "5 Kredita",
                    "10Credits": "10 Kredita",
                    "15Credits": "15 Kredita",
                    "20Credits": "20 Kredita",
                    "25Credits": "25 Kredita",
                    "30Credits": "30 Kredita",
                    "35Credits": "35 Kredita",
                    "40Credits": "40 Kredita",
                    "45Credits": "45 Kredita",
                    "50Credits": "50 Kredita",
                    "75Credits": "75 Kredita",
                    "100Credits": "100 Kredita"
                }
            },
            "message": {
                "quantityRequired": "Količina je obavezna",
                "paymentMethodRequired": "Molimo dodajte <1>način plaćanja</1> kako biste naručili kredite.",
                "paymentMethodExpired": "Ne možete naručiti kredite jer je vaš zadani <1>način plaćanja</1> istekao, molimo postavite važeći način plaćanja kao zadani kako biste naručili kredite."
            }
        },
        "modal": {
            "header": "Nastavi na naplatu",
            "body": {
                "message": "Naručili ste {{credits}} Kredita",
                "confirmationMessage": "Ako želite potvrditi narudžbu, nastavite na naplatu, inače možete otkazati narudžbu."
            },
            "button": {
                "cancel": "Otkaži",
                "checkout": "Naplata"
            }
        },
        "message": {
            "error": "Nešto je pošlo po zlu! Molimo osvježite stranicu i pokušajte ponovo!"
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transakcija Uspješna :)",
            "description": "Uspješno ste kupili kredite koji će uskoro biti dodani na vaš račun!",
            "button": {
                "returnToDashboard": "Povratak na Nadzornu ploču"
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transakcija Otkazana :(",
            "description": "Transakcija je otkazana... Molimo pokušajte ponovo kasnije!",
            "button": {
                "returnToDashboard": "Povratak na Nadzornu ploču"
            }
        }
    }
};

export default creditsHR;